import React, { useMemo } from 'react';
import { Select, Space } from 'antd';
import Icon from '@mdi/react';
import { mdiMagnify, mdiAccountMultiplePlus, mdiLinkVariant, mdiLinkPlus } from '@mdi/js';
import Ninja from '@ninja';

const ChannelSelect = ({ placeholder = 'Select Channel', ...rest }) => {
  const options = useMemo(
    () => [
      { value: 'facebook', label: 'Meta', icon: '/icons/networks/facebook.svg' },
      { value: 'google', label: 'Google', icon: '/icons/networks/google.svg' },
      { value: 'bing', label: 'Bing', icon: '/icons/networks/bing.svg' },
      {
        value: 'seo',
        label: 'SEO',
        icon: <Icon path={mdiMagnify} size={0.8} color={Ninja.colors.medium} />,
      },
      {
        value: 'referral',
        label: 'Referral',
        icon: <Icon path={mdiAccountMultiplePlus} size={0.8} color={Ninja.colors.medium} />,
      },
      {
        value: 'custom_urls',
        label: 'Custom URLs',
        icon: <Icon path={mdiLinkPlus} size={0.8} color={Ninja.colors.medium} />,
      },
      {
        value: 'direct',
        label: 'Direct',
        icon: <Icon path={mdiLinkVariant} size={0.8} color={Ninja.colors.medium} />,
      },
    ],
    []
  );

  return (
    <Select
      mode='multiple'
      style={{ width: '100%' }}
      placeholder={placeholder}
      maxTagCount='responsive'
      allowClear
      {...rest}
    >
      {options.map(({ value, label, icon }) => (
        <Select.Option key={value} value={value} label={label}>
          <Space className='text-xs flex items-center '>
            {typeof icon === 'string' ? <img src={icon} alt={label} className='w-4 h-4' /> : icon}
            {label}
          </Space>
        </Select.Option>
      ))}
    </Select>
  );
};

export default ChannelSelect;
